export default {
  subtitle: "Chilean Bank Accounts",
  path: "bank_accounts_cl",
  paragraphs: [
    "Your Chilean Bank Account will be available within your credentials and your Portal. You can always check it in Bank Accounts > FacilitaPay Payin accounts",
    "To add your customer's bank account in Chile, use the endpoint below. Replace :id with the subject_id:"
  ],
  request: {
    method: "POST",
    endpoint: "/subject/:id/bank_accounts",
    payload: {
      "bank_account": {
        "account_type": "conta-corrente",
        "account_number": "06553536",
        "owner_document_number": "552211774",
        "owner_document_type": "rut",
        "owner_name": "Francisco Muñoz",
        "branch_country": "CHL",
        "bank": {
          "code": "055",
          "name": "Banco Consorcio"
        },
        "currency": "CLP"
      }
    },
    responses: {
      "data": {
        "routing_number": null,
        "pix_info": null,
        "owner_name": "Francisco Muñoz",
        "owner_document_number": "552211774",
        "owner_document_type": "rut",
        "owner_company": {
          "social_name": "POWER HOME THEATER",
          "id": "f64e512c-1a81-42d9-9ac9-05f369bc98e3",
          "document_type": "tax_id",
          "document_number": "2348909854385"
        },
        "nickname": null,
        "intermediary_bank_account": null,
        "id": "76c82ab0-a0fb-4536-8c48-fe261e6d0b2d",
        "iban": null,
        "currency": "CLP",
        "branch_number": null,
        "branch_country": "CHL",
        "bank": {
          "swift": null,
          "name": "Banco Consorcio",
          "ispb": null,
          "id": "d6870540-f347-4af6-b333-75b515ef5108",
          "country": "CHL",
          "code": "055"
        },
        "account_type": "conta-corrente",
        "account_number": "06553536",
        "aba": null
    }
  }
  },
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "A Chilean customer UUID"
    }
  ],
  parameterPayload: [
    {
      name: "bank_account",
      type: "object",
      required: true,
      description: "An object containing:",
      is_parent: true
    },
    {
      name: "bank_account.account_number",
      type: "string",
      required: true,
      description: "Account number. In some banks, the number is the same as the owner's RUT",
    },
    {
      name: "bank_account.currency",
      type: "string",
      required: true,
      description: "Account currency. For Chile, use 'CLP'.",
    },
    {
      name: "bank_account.bank",
      type: "object",
      required: true,
      description: "An object containing information from the bank which the account belongs:",
      is_parent: true
    },
    {
      name: "bank_account.bank.name",
      type: "string",
      required: true,
      description: "Bank name",
    },
    {
      name: "bank_account.bank.code",
      type: "string",
      required: true,
      description: "Bank Code",
    },
    {
      name: "bank_account.account_type",
      type: "string",
      required: false,
      description: "Account type. In Chile, they will be mapped as follows: Conta Corriente -> 'conta-corrente'; Cuenta de Ahorros -> 'poupanca'; Cuentas Nómina -> 'salary'; Cuentas pensionales -> 'payment'",
    },
    {
      name: "bank_account.owner_document_number",
      type: "string",
      required: false,
      description: "Document number for the account owner",
    },
    {
      name: "bank_account.owner_document_type",
      type: "string",
      required: false,
      description: "rut (downcase)",
    },
    {
      name: "bank_account.owner_name",
      type: "string",
      required: false,
      description: "Account owner full name",
    },
    {
      name: "bank_account.branch_country",
      type: "String",
      required: false,
      description: "An ISO 3166-1 alpha-3 country code of the account country. For Chile, use 'CHL'.",
    },
    {
      name: "bank_account.branch_number",
      type: "string",
      required: false,
      description: "Account branch number",
    },
  ],
  footerNotes: "¹The RUT is an unique identification code for Chile citizens or companies, and is used to track tax information and other identification purposes by the government. ²If a previously registered bank code is provided, its corresponding name will be overwritten with the recorded in our database."
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/BankAccount/BankAccountsRegistrationCL.js